/**
 * 格式化
 * @param number 要格式化的数字
 * @param n 保留的小位数
 * @param x 几个数字一次间隔
 */
export const wrapCurrency = (num, n = 2, x = 3) => {
  const nu = new Number(num ?? 0);
  const re = '\\d(?=(\\d{' + x + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return nu.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

/**
 * format number
 * @param num
 */
export const formatNumber = (num: number) => {
  return new Intl.NumberFormat('en-US', { style: 'decimal' }).format(num);
};

/**
 * format number with sign
 * @param num
 */
export const formatNumberWithSign = (num: number) => {
  const sign = num > 0 ? '+' : '';
  const displayStr = new Intl.NumberFormat('en-US', { style: 'decimal' }).format(num);
  return sign + displayStr;
};

/**
 * format money
 * @param amount
 */
export const formatMoney = (amount: number, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
};
